import { render, staticRenderFns } from "./AssetsGreen.vue?vue&type=template&id=63a8e954&scoped=true"
import script from "./AssetsGreen.vue?vue&type=script&lang=js"
export * from "./AssetsGreen.vue?vue&type=script&lang=js"
import style0 from "./AssetsGreen.vue?vue&type=style&index=0&id=63a8e954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a8e954",
  null
  
)

export default component.exports